module.exports = __webpack_public_path__ + "static/media/vanDark.a1cb78b1.svg";